import type { TRequestMethod } from '@common/http/definitions'

import simpleAjax from '../simple/ajax'

interface IProps {
  readonly data?: TAnyObject | undefined
  readonly corsOrigin?: string
  readonly contentType?: string | undefined
  readonly method?: TRequestMethod
}

/**
 * Az egyszerű ajax fölé egy promise wrapper.
 * @param url   - Hova lőjjük a request-et.
 * @param props - Lehetséges ajax beállítások.
 */
export default function ajax (url: string, props: IProps): Promise<XMLHttpRequest | null> {
  return new Promise((resolve) => {
    simpleAjax({
      url,
      onSuccess: (xhr) => {
        resolve(xhr)
      },
      onError: () => {
        resolve(null)
      },
      ...props
    })
  })
}
